/**
 * Convert an angle value from Rad to Deg
 *
 * @see {@link http://stackoverflow.com/questions/9705123/how-can-i-get-sin-cos-and-tan-to-use-degrees-instead-of-radians}
 *
 * @export
 * @param {number} angle expressed in Rad
 * @returns {number} angle expressed in Deg
 */
export function toDeg(angle) {
	return angle * (180 / Math.PI);
}

/**
 * Convert an angle value from Deg to Rad
 *
 * @see {@link http://stackoverflow.com/questions/9705123/how-can-i-get-sin-cos-and-tan-to-use-degrees-instead-of-radians}
 *
 * @export
 * @param {number} angle expressed in Deg
 * @returns {number} angle expressed in Rad
 */
export function toRad(angle) {
	return angle * (Math.PI / 180);
}
